export default __webpack_public_path__ + "static/media/scotiabank.b6a8c18f.JPG";